module.exports = __webpack_public_path__ + "img/pop_bg_vn.f9f13d7d.png";